import { render, staticRenderFns } from "./NotRegisteredInSefos.vue?vue&type=template&id=3ecf2e87"
import script from "./NotRegisteredInSefos.vue?vue&type=script&lang=js"
export * from "./NotRegisteredInSefos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports